import script from "./Statuses.vue?vue&type=script&setup=true&lang=js"
export * from "./Statuses.vue?vue&type=script&setup=true&lang=js"

import "./Statuses.vue?vue&type=style&index=0&id=f3c88e3a&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3c88e3a"]])

export default __exports__